import { componentName, LinkClass } from './LinkClass';
import '@descope-ui/descope-text';

customElements.define(componentName, LinkClass);

export { LinkClass, componentName };
